export default "__VITE_ASSET__DtgmUphx__"